export const Environments = {
  Utiq: 'Utiq',
};
